<template>
  <div class="grid-header" :class="{ scrolling: requisitions.length > 10 }">
    <div
      class="submission-rate-header grid-cell new-body-text"
      @click="$emit('update:sort', { sort: 'fill_rate', sortDirection: getNextSortDirection('fill_rate') })"
      @mouseenter="hoveredHeader = 'fill_rate'"
      @mouseleave="hoveredHeader = null"
    >
      Submission Rate
      <v-icon
        v-if="currentSortValue === 'fill_rate' || hoveredHeader === 'fill_rate'"
        :icon="currentSortDirection === 'asc' ? '$chevron-up' : '$chevron-down'"
        size="14px"
      />
    </div>
    <div
      class="req-name grid-cell new-body-text"
      @click="$emit('update:sort', { sort: 'title', sortDirection: getNextSortDirection('title') })"
      @mouseenter="hoveredHeader = 'title'"
      @mouseleave="hoveredHeader = null"
    >
      Requisition Name
      <v-icon
        v-if="currentSortValue === 'title' || hoveredHeader === 'title'"
        :icon="currentSortDirection === 'asc' ? '$chevron-up' : '$chevron-down'"
        size="14px"
      />
    </div>
    <div
      class="req-id grid-cell new-body-text"
      @click="$emit('update:sort', { sort: 'ats_requisition_label', sortDirection: getNextSortDirection('ats_requisition_label') })"
      @mouseenter="hoveredHeader = 'ats_requisition_label'"
      @mouseleave="hoveredHeader = null"
    >
      Req ID
      <v-icon
        v-if="currentSortValue === 'ats_requisition_label' || hoveredHeader === 'ats_requisition_label'"
        :icon="currentSortDirection === 'asc' ? '$chevron-up' : '$chevron-down'"
        size="14px"
      />
    </div>
    <div
      class="department grid-cell new-body-text"
      @click="$emit('update:sort', { sort: 'department', sortDirection: getNextSortDirection('department') })"
      @mouseenter="hoveredHeader = 'department'"
      @mouseleave="hoveredHeader = null"
    >
      Department
      <v-icon
        v-if="currentSortValue === 'department' || hoveredHeader === 'department'"
        :icon="currentSortDirection === 'asc' ? '$chevron-up' : '$chevron-down'"
        size="14px"
      />
    </div>
    <div
      class="req-status-header grid-cell new-body-text"
      @click="$emit('update:sort', { sort: 'status', sortDirection: getNextSortDirection('status') })"
      @mouseenter="hoveredHeader = 'status'"
      @mouseleave="hoveredHeader = null"
    >
      Status
      <v-icon
        v-if="currentSortValue === 'status' || hoveredHeader === 'status'"
        :icon="currentSortDirection === 'asc' ? '$chevron-up' : '$chevron-down'"
        size="14px"
      />
    </div>
    <div class="req-settings-header grid-cell new-body-text" :class="{ scrolling: requisitions.length > 10 }">
      Edit Settings
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const hoveredHeader = ref(null);

const props = defineProps({
  requisitions: { type: Array, required: true },
  currentSort: { type: String, required: true },
});

defineEmits(['update:sort']);

const currentSortValue = computed(() => props.currentSort.replace('-', ''));
const currentSortDirection = computed(() => (props.currentSort.startsWith('-') ? 'asc' : 'desc'));

const getNextSortDirection = (sort) => {
  if (sort === currentSortValue.value) {
    return currentSortDirection.value === 'asc' ? 'desc' : 'asc';
  }

  return 'desc';
};
</script>

<style lang="less" scoped>
.grid-header {
  display: grid;
  grid-template-columns: minmax(100px, 145px) minmax(175px, 1fr) minmax(70px, 95px) minmax(85px, 206px) minmax(75px, 100px) minmax(65px, 102px);
  width: 100%;
}

.grid-header.scrolling {
  grid-template-columns: minmax(100px, 145px) minmax(175px, 1fr) minmax(70px, 95px) minmax(85px, 206px) minmax(75px, 100px) minmax(72px, 109px);
}

.grid-header .grid-cell {
  background: @bg-canvas;
  padding: 11px;
  color: @text-dark;
  border-bottom: 1px solid @stroke-default;

  &:not(.req-settings-header) {
    cursor: pointer;
  }

  &.submission-rate-header, &.req-status-header {
    text-align: center;
  }

  &.req-settings-header {
    word-wrap: break-word;
  }
}
</style>
